import NuqsProvider from './Nuqs';

export default NuqsProvider;
